export let queryParams = {
  apiVersion: "/api/v2/",
  date: ""
};

if (process.env.NODE_ENV === "development") {
  queryParams = {
    apiVersion: "/api/v2/",
    date: "2017-07-31"
  };
}

export function getUserDashboardPreferences() {
  let params = document
    .getElementById("user-box-container")
    .children[0].getAttribute("data-react-props");
  let obj = JSON.parse(params);
  return obj.currentUser.params.dashboardPreferences;
}
